import React from 'react'
import PropTypes from 'prop-types'
import { Redirect, Route, Switch } from 'react-router'
import { toTitleCase } from 'utils/stringHelpers'
import BackLink from 'components/BackLink'
import ProductLessons from 'components/ProductLessons'

import { Wrapper, SiteSelectorK8WrapperDark } from './component.styles'
import SiteSelector from 'components/SiteSelector'

import { TAB_TITLE } from 'containers/Product/constants'

const LessonsComponent = props => {
  const {
    classes = [],
    contentfulCourses,
    courseLinks,
    match,
    goToDashboard,
    productName,
    productTabTitle,
    onClassClick,
    onCourseClick,
  } = props || {}

  const baseUrl = match.url
  const basePath = match.path
  const productTitle = toTitleCase(`${productName?.replace('-', ' ')} Lessons`)
  const withVerb = `${basePath}/:verb(preview|teach)`
  const tabTitles = {
    page: productTabTitle,
    tab: TAB_TITLE,
  }
  document.title = `${tabTitles.page} | ${tabTitles.tab}`

  return (
    <Wrapper>
      <Switch>
        {/* Previewing or teaching a with nothing specified; go to just /lessons */}
        <Redirect exact from={`${withVerb}`} to={`${baseUrl}`} />
        {/* Show courses to preview and classes to teach (if there are any) */}
        <Route
          path={baseUrl}
          render={() => (
            <>
              <nav className="breadcrumbs">
                <BackLink onClick={goToDashboard}>Dashboard</BackLink>
                <SiteSelectorK8WrapperDark>
                  <SiteSelector />
                </SiteSelectorK8WrapperDark>
              </nav>

              <ProductLessons
                classes={classes}
                contentfulCourses={contentfulCourses}
                courseLinks={courseLinks}
                onClassClick={onClassClick}
                onCourseClick={onCourseClick}
                program={productName}
                title={productTitle}
              />
            </>
          )}
        />
      </Switch>
    </Wrapper>
  )
}

LessonsComponent.propTypes = {
  classes: PropTypes.arrayOf(
    PropTypes.shape({
      contentfulID: PropTypes.string,
      completeLessons: PropTypes.number,
      instance: PropTypes.string,
      scoId: PropTypes.number,
      totalLessons: PropTypes.number,
      title: PropTypes.string,
    }),
  ),
  contentfulCourses: PropTypes.arrayOf(
    PropTypes.shape({
      displayTitle: PropTypes.string,
    }),
  ).isRequired,
  courseLinks: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string,
      title: PropTypes.string,
    }),
  ).isRequired,
  goToDashboard: PropTypes.func.isRequired,
  match: PropTypes.shape({
    url: PropTypes.string,
    path: PropTypes.string,
    params: PropTypes.shape({
      productName: PropTypes.string,
    }),
  }).isRequired,
  onClassClick: PropTypes.func.isRequired,
  onCourseClick: PropTypes.func.isRequired,
  productName: PropTypes.string,
  productTabTitle: PropTypes.string,
}

export default LessonsComponent
